import { useDispatch } from "react-redux";

import { orderActions } from "../../store/orderSlice";

function useSubmitPrivacyPolicy() {
  const dispatch = useDispatch();

  const setPrivacyPolicy = (val) => {
    dispatch(orderActions.setPrivacyPolicy(val));
  };

  return setPrivacyPolicy;
}
export default useSubmitPrivacyPolicy;
